import * as lucideReact from 'lucide-react';

export type Icon = typeof lucideReact.Icon;

export const Icons = {
  Spinner: lucideReact.LoaderCircle,
  Dropdown: lucideReact.ChevronsUpDown,
  Close: lucideReact.CircleX,
  Alert: lucideReact.AlertCircle,
  Info: lucideReact.Info,
  Left: lucideReact.ArrowLeft,
  Right: lucideReact.ArrowRight,
  Logout: lucideReact.LogOut,
  Add: lucideReact.Plus,
  Remove: lucideReact.Trash,
  New: lucideReact.SquarePen,
  SplitY: lucideReact.SquareSplitVertical,
  Divide: lucideReact.Slash,
  Drag: lucideReact.GripHorizontal,
  Note: lucideReact.NotebookPen,
  LightTheme: lucideReact.Sun,
  DarkTheme: lucideReact.Moon,
  SystemTheme: lucideReact.Monitor,
  Camera: lucideReact.Camera,
  Profile: lucideReact.User,
  Email: lucideReact.Mail,
  Password: lucideReact.KeyRound,
  Retry: lucideReact.RotateCcw,
  NotComplete: lucideReact.Circle,
  Complete: lucideReact.CircleCheck,
  Github: lucideReact.GitBranch,
  Download: lucideReact.Download,
  Weapon: lucideReact.Swords,
  Artifact: lucideReact.Gem,
  Team: lucideReact.Users,
  Substat: lucideReact.Sparkles,
  MainStat: lucideReact.CircleDot,
  Star: lucideReact.Star,
  DragVertical: lucideReact.GripVertical,
  Caret: lucideReact.ChevronDown,
};
